var _rect, _rect2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFeatureQuiz(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.833252,
    y: 0.5,
    width: 47,
    height: 47,
    rx: 9.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.833252,
    y: 0.5,
    width: 47,
    height: 47,
    rx: 9.5,
    stroke: "#EAECF0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.3253 14.124C26.3519 13.9097 26.3084 13.6925 26.2013 13.505C26.0941 13.3174 25.9292 13.1696 25.7311 13.0836C25.533 12.9976 25.3124 12.9781 25.1022 13.0279C24.8921 13.0777 24.7037 13.1942 24.5653 13.36L15.6353 24.075C15.4813 24.26 15.3253 24.448 15.2113 24.613C15.1033 24.768 14.9073 25.075 14.9013 25.477C14.8978 25.7046 14.9461 25.9301 15.0426 26.1362C15.1391 26.3424 15.2812 26.5239 15.4583 26.667C15.7713 26.92 16.1323 26.965 16.3213 26.982C16.5213 27 16.7643 27 17.0053 27H23.2003L22.3403 33.876C22.3134 34.0906 22.3567 34.3081 22.4639 34.4959C22.571 34.6838 22.7361 34.8318 22.9345 34.9179C23.1329 35.0039 23.3538 35.0234 23.5642 34.9733C23.7746 34.9232 23.963 34.8062 24.1013 34.64L33.0313 23.925C33.1853 23.74 33.3413 23.552 33.4553 23.387C33.5633 23.232 33.7593 22.925 33.7653 22.523C33.7688 22.2954 33.7205 22.0699 33.624 21.8638C33.5275 21.6576 33.3854 21.4761 33.2083 21.333C32.8953 21.08 32.5343 21.035 32.3453 21.018C32.1453 21 31.9033 21 31.6613 21H25.4663L26.3263 14.124H26.3253Z",
    fill: "#82C100"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeatureQuiz);
export default __webpack_public_path__ + "static/media/feature_quiz.f016df818e1eb02da96f414804a1fe05.svg";
export { ForwardRef as ReactComponent };